"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Modal = require('react-modal');

var playButton = require('../../../assets/icon_play_button.svg');

var closeButton = require('../../../assets/icon_close_button.svg');

var CustomControls_1 = require("./CustomControls");

var defaultStyles = {
  overlay: {
    backgoundColor: 'transparent',
    zIndex: '99999',
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    overflow: 'hidden'
  }
};
Modal.defaultStyles = defaultStyles; // Make sure to bind modal to your yar (http://reactcommunity.org/react-modal/accessibility/)

if (typeof document !== 'undefined' && document.getElementById('#___gatsby')) {
  Modal.setAppElement('#___gatsby');
}

var VideoOverlay =
/** @class */
function (_super) {
  __extends(VideoOverlay, _super);

  function VideoOverlay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.customStyles = {
      content: {
        backgroundColor: 'rgba(0, 0, 0, 1)',
        border: '0 solid',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        borderRadius: '0',
        position: 'relative',
        height: '100%',
        boxSizing: 'border-box',
        padding: 0,
        overflow: 'hidden'
      }
    };
    return _this;
  }

  VideoOverlay.prototype.render = function () {
    var _a = this.props,
        posterImage = _a.posterImage,
        videoElement = _a.videoElement,
        modalIsOpen = _a.modalIsOpen,
        closeModal = _a.closeModal,
        play = _a.play,
        pause = _a.pause,
        isVideoPlaying = _a.isVideoPlaying,
        isLoading = _a.isLoading,
        customControls = _a.customControls,
        controls = _a.controls,
        mouseMoving = _a.mouseMoving;
    return react_1["default"].createElement(react_1["default"].Fragment, null, posterImage, react_1["default"].createElement(PosterImageOverlay, null, react_1["default"].createElement("img", {
      src: playButton
    })), react_1["default"].createElement(Modal, {
      isOpen: modalIsOpen,
      onRequestClose: function onRequestClose() {
        return closeModal();
      },
      style: this.customStyles
    }, react_1["default"].createElement(VideoContainer, null, videoElement), react_1["default"].createElement(CustomControls_1.CustomControls, {
      isVideoPlaying: !!isVideoPlaying,
      mouseMoving: !!mouseMoving,
      isLoading: !!isLoading,
      customControls: customControls,
      controls: controls,
      color: '#FFFFFF',
      play: play,
      pause: pause
    }), react_1["default"].createElement(CloseTrigger, {
      onClick: function onClick() {
        return closeModal();
      }
    }, react_1["default"].createElement("img", {
      src: closeButton
    }))));
  };

  return VideoOverlay;
}(react_1.Component);

exports.VideoOverlay = VideoOverlay; // Styling for poster / preview image overlay (basically a big button)

var PosterImageOverlay = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background-color: rgba(0, 0, 0, 0.1);\n  img {\n    ", "\n    opacity: 1;\n  }\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n"], ["\n  ", "\n  background-color: rgba(0, 0, 0, 0.1);\n  img {\n    ", "\n    opacity: 1;\n  }\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n"])), CustomControls_1.SharedOverlayStyles, CustomControls_1.SharedPlayButtonStyles);
var VideoContainer = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  height: auto;\n  max-height: 100%;\n  width: 100%;\n  max-width: 100%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n"], ["\n  position: absolute;\n  height: auto;\n  max-height: 100%;\n  width: 100%;\n  max-width: 100%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n"])));
var CloseTrigger = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  z-index: 120;\n  top: 0;\n  right: 0;\n  position: absolute;\n  padding: 10px;\n  width: 24px;\n  height: 24px;\n  padding: 20px;\n  box-sizing: content-box;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  cursor: pointer;\n  z-index: 120;\n  top: 0;\n  right: 0;\n  position: absolute;\n  padding: 10px;\n  width: 24px;\n  height: 24px;\n  padding: 20px;\n  box-sizing: content-box;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"])));
exports["default"] = VideoOverlay;
var templateObject_1, templateObject_2, templateObject_3;